<ng-template #contactBlock let-contact="contact" let-titleKey="titleKey" let-extra="extra">
  <div class="mt-3 flex flex-col gap-1">
    <div class="typo-h8-semibold mb-1 font-medium text-primary-blue">{{ titleKey | translate }}</div>
    <div class="flex w-full items-start justify-between gap-2">
      <h5 class="typo-h5-medium truncate text-text-light" [class.text-text-primary]="contact.contactName">
        {{ contact.contactName || ('health_history_patient_secondary_contact_name' | translate) }}
      </h5>
      <h5 class="typo-h5-medium min-w-26 text-text-light" [class.text-text-tertiary]="contact.phoneNumber">
        {{ contact.phoneNumber ? (contact.phoneNumber | libPhoneFormat) : ('health_history_patient_secondary_contact_phone' | translate) }}
      </h5>
    </div>
    @if (extra) {
      <span class="typo-h6-light text-text-secondary">{{ extra }}</span>
    }
  </div>
</ng-template>

@if (emergency(); as e) {
  <ng-container
    *ngTemplateOutlet="contactBlock; context: {
      contact: e,
      titleKey: 'health_history_patient_secondary_emergency_contact',
      extra: e.relationshipToPatient
    }"
  ></ng-container>
}
@if (pharmacy(); as p) {
  <ng-container
    *ngTemplateOutlet="contactBlock; context: {
      contact: p,
      titleKey: 'health_history_patient_secondary_pharmacy',
      extra: p.address
    }"
  ></ng-container>
}
@if (physician(); as ph) {
  <ng-container
    *ngTemplateOutlet="contactBlock; context: {
      contact: ph,
      titleKey: 'health_history_patient_secondary_physician',
      extra: ph.speciality
    }"
  ></ng-container>
}
